import type { RequirementStatus } from '../api/requirements';
import { pipelineFor, type PipelineSegment } from '../lib/statusMapping';

type Props = {
  readonly status: RequirementStatus;
};

export function StatusPipeline({ status }: Props) {
  const { segments, label } = pipelineFor(status);
  return (
    <div className="status-pipe" aria-label={label}>
      {segments.map((s, i) => (
        <div key={i} className={'seg ' + segClass(s)} />
      ))}
      <span className="label">{label}</span>
    </div>
  );
}

function segClass(s: PipelineSegment): string {
  return s === 'idle' ? '' : s;
}
